<template>
    <div class="company-reservations-overview-component">
        
		<div class="row">
            <!-- Datepicker -->
			<div class="col-md-3">
                <!-- :min-page="{ year: (new Date()).getFullYear(), month: (new Date()).getMonth() + 1 }" -->
                <!-- :available-dates="availableDates" -->
				<v-date-picker
					ref="calendar"
					mode="single"
					v-model="date"
					:locale="locale"
					:attributes="attrs"
					is-inline
					@update:from-page="loadDates"
					@dayclick="loadTimes"
				/>
			</div>
            <div class="col-md-1">
            </div>
            <!-- Timeslots -->
            <div class="col-md-8" v-if="date">

                <div class="row">
                    <div class="col-md-6">
                                
                        <p class="h4 text-primary font-weight-bold">{{ 'reservations.select_time' | translate }}</p>

                        <p class="h5 mb-3">{{ date | moment("dddd D MMMM YYYY") }}</p>


                    </div>
                    <div class="col-md-6 text-right">
                        
                        <!-- @click="openPrintWindow($event)" -->

                        <div class="dropdown">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {{ 'reservations.exports.button' | translate }}
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a :href="printUrl" target="_blank" class="dropdown-item">{{ 'reservations.exports.print_list' | translate }}</a>
                                <a :href="printMonthlyUrl" target="_blank" class="dropdown-item">{{ 'reservations.exports.print_monthly_list' | translate }}</a>
                                <div class="dropdown-divider"></div>
                                <a :href="excelUrl" target="_blank" class="dropdown-item">{{ 'reservations.exports.excel_list' | translate }}</a>
                                <a :href="excelMonthlyUrl" target="_blank" class="dropdown-item">{{ 'reservations.exports.excel_monthly_list' | translate }}</a>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="times" v-for="(items, descriptionGroup) in timeslots" :key="descriptionGroup">
                    
                    <p v-if="has_multiple_descriptions" class="h5 text-primary font-weight-bold">
                        <span v-if="descriptionGroup != 'null'">{{ descriptionGroup }}</span>
                        <span v-else>{{ 'reserve.default_description' | translate }}</span>
                    </p>

                    <div class="row">
                        <div class="col-md-4 mb-3" v-for="timeslot in items" :key="timeslot.id">
                            <button 
                                type="button"
                                class="btn btn" 
                                :class="true ? 'btn-primary' : 'btn-light'" 
                                :disabled="false"
                                @click="onTimeslotClick(timeslot)"
                            >
                                {{ timeslot.label }}
                            </button>
                        </div>
                    </div>

                </div>
                <div v-if="staff.length > 0">
                    
                    <!-- staff select -->
                    <label class="text-primary">{{ 'reservations.health_declaration.label' | translate }}</label>
                    <div class="d-flex">
                        <div class="flex-fill">
                            <multiselect
                                ref="staffMultiselect"
                                v-model="computedStaff"
                                :options="staff"
                                track-by="id"
                                label="name"
                                :multiple="true"
                                :close-on-select="false"
                                
                                @select="onHealthDeclarationChange"
                                @remove="onHealthDeclarationChange"
                                @close="saveHealthDeclaraction"
                                :loading="healthDeclaration.loading"
                                :disabled="healthDeclaration.loading"
                                :showLabels="true"
                                :showPointer="false"
                                :placeholder="'reservations.health_declaration.placeholder' | translate"
                                :selectLabel="'reservations.health_declaration.select' | translate"
                                :deselectLabel="'reservations.health_declaration.deselect' | translate"
                                :selectedLabel="'reservations.health_declaration.selected' | translate"
                            >
                            </multiselect>
                        </div>
                        <div class="ml-3" v-if="healthDeclaration.dirty">
                            <button class="btn btn-success py-2 px-3" @click="saveHealthDeclaraction"><i class="fa fa-save"></i></button>
                        </div>
                    </div>

                </div>

            </div>

            <div v-if="timeslot" class="col-md-12 mt-3">

                <p class="h4 text-primary font-weight-bold">{{ 'reservations.reservations' | translate }}</p>

                <p class="h5 mb-3">{{ timeslot.label }}</p>

                <div class="row">
                    <div class="col-md-7">
                        
                        <!-- Reservations -->

                        <!-- <p class="h5 text-primary font-weight-bold">{{ 'reservations.reservations_inside' | translate }}</p> -->

                        <table v-if="groups.length > 0" class="table">
                            <tbody v-for="(group) in groups" :key="group.id">
                                <tr @click="selected_group == group.id ? selected_group = 0 : selected_group = group.id" :class="{ 'text-danger' : group.status == 'payment_pending' }" style="cursor: pointer;">
                                    <th scope="row">{{ 'reservations.table' | translate }} {{ group.user.username }}</th>
                                    <td>{{ group.full_name }}</td>
                                    <!-- <td>{{ group.num_guests }}</td> -->
                                    <td class="w-25 text-nowrap">
                                        <div v-if="!group.checked_in_at" class="btn btn-sm btn-success" @click="checkIn(group)"><i class="fa fa-sign-in-alt mr-2" />{{ 'reservations.checkin' | translate }}</div>
                                        <div v-if="group.checked_in_at && !group.checked_out_at" class="btn btn-sm btn-warning" @click="checkOut(group)"><i class="fa fa-sign-out-alt mr-2" />{{ 'reservations.checkout' | translate }}</div>
                                        <div class="btn btn-sm btn-danger" @click="removeReservation(group)"><i class="fa fa-trash" /></div>
                                    </td>
                                </tr>
                                <tr v-if="selected_group == group.id">
                                    <td colspan="3">
                                        <b v-if="group.status == 'payment_pending'" class="text-danger">{{ 'reservations.payment_pending' | translate }}<br /></b>
                                        <b v-else-if="group.payment && group.payment.status == 'paid'">
                                            {{ 'reservations.amount_paid' | translate }} {{ group.payment.amount_incl | currency }}
                                            <br />
                                        </b>
                                        <span v-if="group.checked_in_at"><i class="fa fa-sign-in-alt text-success"></i> {{ group.checked_in_at | moment("LLLL") }} <br /></span>
                                        <span v-if="group.checked_out_at"><i class="fa fa-sign-out-alt text-warning"></i> {{ group.checked_out_at | moment("LLLL") }} <br /></span>
                                        <i class="fas fa-phone"></i> {{ group.telephone }} <br />
                                        <span v-if="current_user.id != group.user_id">
                                            <i class="fas fa-envelope"></i> {{ group.email }} <br />
                                            <span v-if="group.receive_newsletter" >{{ 'reservations.receive_newsletter' | translate }}</span>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-else>
                            {{ 'reservations.no_reservations' | translate }}
                        </div>

                        <!-- <p class="h5 text-primary font-weight-bold mt-4">{{ 'reservations.reservations_outside' | translate }}</p>

                        <table v-if="outside_groups.length > 0" class="table">
                            <tbody v-for="(group, index) in outside_groups" :key="group.id">
                                <tr @click="selected_group == group.id ? selected_group = 0 : selected_group = group.id" :class="{ 'text-danger' : group.status == 'payment_pending' }" style="cursor: pointer;">
                                    <th scope="row">{{ 'reservations.table' | translate }} {{ index + 1 }}</th>
                                    <td>{{ group.full_name }}</td>
                                    <td>{{ group.num_guests }}</td>
                                    <td><div class="btn btn-sm btn-danger" @click="removeReservation(group)"><i class="fa fa-trash" /></div></td>
                                </tr>
                                <tr v-if="selected_group == group.id">
                                    <td colspan="4">
                                        <b v-if="group.status == 'payment_pending'" class="text-danger">{{ 'reservations.payment_pending' | translate }}<br /></b>
                                        <b v-else-if="group.payment && group.payment.status == 'paid'">
                                            {{ 'reservations.amount_paid' | translate }} {{ group.payment.amount_incl | currency }}
                                            <br />
                                        </b>
                                        <i class="fas fa-phone"></i> {{ group.telephone }} <br />
                                        <span v-if="current_user.id != group.user_id">
                                            <i class="fas fa-envelope"></i> {{ group.email }} <br />
                                            <span v-if="group.receive_newsletter" >{{ 'reservations.receive_newsletter' | translate }}</span>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-else>
                            {{ 'reservations.no_reservations' | translate }}
                        </div>
                        -->
                    </div>
                    <div class="col-md-5">

                        <!-- Add reservation form -->
		                <form ref="add-reservation-form" v-on:submit.prevent="addReservation" novalidate>

                            <!-- create_account 
                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="create_account" :class="{'is-invalid': errors.create_account}" v-model="add_form.create_account">
                                    <label class="custom-control-label" for="create_account">{{ 'reservations.create_account' | translate }}</label>
                                    <div v-if="errors.create_account" class="invalid-feedback">
                                        {{ errors.create_account[0] }}
                                    </div>
                                </div>
                            </div> -->

                            <!-- email 
                            <div v-if="add_form.create_account" class="form-group row">
                                <label for="email" class="col-sm-3 col-form-label">{{ 'reservations.email' | translate }}<span class="required">*</span></label>
                                <div class="col-sm-9">
                                    <div class="input-group">
                                        <input type="email" :class="{ 'form-control': true, 'is-invalid': errors.email}" id="email" v-model="add_form.email" @input="checkEmail()" required>
                                        <div class="input-group-append">
                                            <span v-if="!emailChecked" class="input-group-text"><span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span></span>
                                        </div>
										<div v-if="errors.email" class="invalid-feedback">
											{{ errors.email[0] }}
										</div>
                                    </div>
                                </div>
                            </div>-->
                            
                            <div v-if="add_form_user">
                                {{ add_form_user.first_name }} {{ add_form_user.last_name }}
                            </div>
                            <div v-else>

                                <!-- firstname -->
                                <div class="form-group row">
                                    <label for="firstname" class="col-sm-3 col-form-label">{{ 'reservations.firstname' | translate }}<span class="required">*</span></label>
                                    <div class="col-sm-9">
                                        <input type="text" :class="{ 'form-control': true, 'is-invalid': errors.firstname}" id="firstname" v-model="add_form.firstname" required>
                                        <div v-if="errors.firstname" class="invalid-feedback">
                                            {{ errors.firstname[0] }}
                                        </div> 
                                    </div>
                                </div>
                                
                                <!-- lastname 
                                <div class="form-group row">
                                    <label for="lastname" class="col-sm-3 col-form-label">{{ 'reservations.lastname' | translate }}<span class="required">*</span></label>
                                    <div class="col-sm-9">
                                        <input type="text" :class="{ 'form-control': true, 'is-invalid': errors.lastname}" id="lastname" v-model="add_form.lastname" required>
                                        <div v-if="errors.lastname" class="invalid-feedback">
                                            {{ errors.lastname[0] }}
                                        </div> 
                                    </div>
                                </div> -->
                                
                                <!-- telephone 
                                <div class="form-group row">
                                    <label for="telephone" class="col-sm-3 col-form-label">{{ 'reservations.telephone' | translate }}<span class="required">*</span></label>
                                    <div class="col-sm-9">
                                        <input type="telephone" :class="{ 'form-control': true, 'is-invalid': errors.telephone}" id="telephone" v-model="add_form.telephone" required>
                                        <div v-if="errors.telephone" class="invalid-feedback">
                                            {{ errors.telephone[0] }}
                                        </div> 
                                    </div>
                                </div> -->
                            
                            </div>

                            <!-- num_guests 
                            <div class="form-group row">
                                <label for="num_guests" class="col-sm-3 col-form-label">{{ 'reservations.num_guests' | translate }}</label>
                                <div class="col-sm-9">
                                        <select class="form-control" style="width: auto;" :class="{'is-invalid': errors.num_guests}" id="num_guests" v-model="add_form.num_guests" required autocomplete="false">
                                            <option value="0">0</option>
                                            <option v-for="n in 8" :key="n" :value="n">{{ n }}</option>
                                        </select>

                                    <div v-if="errors.num_guests" class="invalid-feedback">
                                        {{ errors.num_guests[0] }}
                                    </div> 
                                </div>
                            </div> -->

                            <!-- inside 
                            <div class="form-group">
                                
                                <div v-if="company.max_guests_inside > 0" class="btn mr-3" :class="[add_form.inside ? 'btn-primary' : 'btn-gray']" @click="add_form.inside = true">
                                    {{ 'reservations.book_inside' | translate }}
                                </div>
                                <div v-if="company.max_guests_outside > 0" class="btn" :class="[!add_form.inside ? 'btn-primary' : 'btn-gray']" @click="add_form.inside = false">
                                    {{ 'reservations.book_outside' | translate }}
                                </div>
                                
                            </div> -->

							<!-- corona_1 -->
							<div class="form-group">
								<div class="custom-control custom-checkbox">
									<input type="checkbox" class="custom-control-input" id="corona_1" :class="{'is-invalid': errors.corona_1}" v-model="add_form.corona_1">
									<label class="custom-control-label" for="corona_1">{{ 'reserve.corona_1' | translate }}</label>
									<div v-if="errors.corona_1" class="invalid-feedback">
										{{ errors.corona_1[0] }}
									</div>
								</div>
							</div>

							<!-- corona_2 -->
							<div class="form-group">
								<div class="custom-control custom-checkbox">
									<input type="checkbox" class="custom-control-input" id="corona_2" :class="{'is-invalid': errors.corona_2}" v-model="add_form.corona_2">
									<label class="custom-control-label" for="corona_2">{{ 'reserve.corona_2' | translate }}</label>
									<div v-if="errors.corona_2" class="invalid-feedback">
										{{ errors.corona_2[0] }}
									</div>
								</div>
							</div>

							<!-- corona_3 -->
							<div class="form-group">
								<div class="custom-control custom-checkbox">
									<input type="checkbox" class="custom-control-input" id="corona_3" :class="{'is-invalid': errors.corona_3}" v-model="add_form.corona_3">
									<label class="custom-control-label" for="corona_3">{{ 'reserve.corona_3' | translate }}</label>
									<div v-if="errors.corona_3" class="invalid-feedback">
										{{ errors.corona_3[0] }}
									</div>
								</div>
							</div>
                            
			                <button type="submit" :disabled="!emailChecked" class="btn btn-primary mt-4">
                                <span v-if="!emailChecked" class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                                {{ add_form_user ? 'reservations.add_user' : 'reservations.new_user' | translate }}
                            </button>

                        </form>

                    </div>
                </div>

            </div>

		</div>
		
		<!-- <v-style>
			:root {
				--timeslot-primary-color: {{ color_primary }};
				--timeslot-primary-color-faded: {{ color_primary_faded }};
				--timeslot-primary-color-text: {{ color_primary_text }};
			}
		</v-style> -->

    </div>
</template>

<script>
    export default {
		name: 'company-reservations-overview',
		props: [
			'company',
            'staff',
			'getDatesUrl',
			'getTimesUrl',
			'getGroupsUrl',
			'getHealthDeclarationUrl',
			'updateHealthDeclarationUrl',
			'checkEmailUrl',
			'checkInUrl',
			'checkOutUrl',
			'removeReservationUrl',
			'addReservationUrl'
		],
		data() {
			return {
				csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                locale: window.default_locale,
                
                date: new Date(),
                timeslot: null,
                availableDates: [],
                timeslots: [],
				groups: [],
                selected_group: 0,
                
                healthDeclaration: {
                    selected: [],
                    loading: false,
                    dirty: false,
                },
                
                add_form: {
                    create_account: false,

                    email: '',
                    firstname: '',
                    lastname: '',
                    telephone: '',
                    num_guests: '',
                    inside: true,
					corona_1: false,
					corona_2: false,
					corona_3: false,
                },
                add_form_user: null,
                
                errors: {},
                attrs: [],
                lastPage: null,
                lastDay: null,
                lastTimeslot: null,

                emailChecked: true,
                checkEmailCancelToken: null,
            }
        },
        mounted() {
            if(this.company.max_guests_inside <= 0) {
                this.add_form.inside = false;
            }
        },
        methods: {

            loadDates(page) {
                if(!page) {
                    page = this.lastPage;
                }
                if(!page) return;

                if(page != this.lastPage) {
					if(this.date && ((this.date.getMonth() + 1) != page.month || this.date.getFullYear() != page.year)) {
						this.date = null;
						this.timeslots = [];
						this.timeslot = null;
                    	this.groups = [];
					}
                }

				this.attrs = [];
                this.availableDates = [''];
				
                this.lastPage = page;

				this.showLoader();

                axios.post(this.getDatesUrl, {
                    month: page.month,
                    year: page.year,
                }) // qs.stringify(this.serverParams)
                .then(response => {
					this.hideLoader();
					
                    _.each(response.data.dates, (num_guests, date) => { 
                        if(num_guests > 0) {
                            this.availableDates.push(date);
                            this.attrs.push({
                                key: date,
                                highlight: 'red',
                                dates: date,
                                popover: {
                                    label: num_guests + ' ' + this.translate('reservations.num_reservations'),
                                },
                            });
                        }
					});
					
					if(this.date) {
						this.loadTimes({id: Vue.moment(this.date).format('YYYY-MM-DD')});
					}
                }).catch(error => {
					this.hideLoader();
					
                    console.error(error);
                    Swal.fire({
                        icon: 'error',
                        title: this.translate('error'),
                    });
                });
            },

            loadTimes(day) {
                if(!day) {
                    day = this.lastDay;
                }
                if(!day) return;

				this.timeslots = [];
				
				if(!this.lastDay || this.lastDay.id != day.id) {
					this.timeslot = null;
                    this.groups = [];
                    this.loadHealthDeclaraction(day.date);
				}

				this.lastDay = day;

				this.showLoader();

                axios.post(this.getTimesUrl, {
                    date: day.id,
                }) // qs.stringify(this.serverParams)
                .then(response => {
					this.hideLoader();
					
                    // this.timeslots = response.data.times;
                    this.timeslots = _.groupBy(response.data.times, 'description');

                    if(!this.date) {
                        this.date = day.date;
                    }
                }).catch(error => {
					this.hideLoader();

                    console.error(error);
                    Swal.fire({
                        icon: 'error',
                        title: this.translate('error'),
                    });
                });
            },

            loadGroups(timeslot) {
                if(!timeslot) {
                    timeslot = this.timeslot;
                }
                if(!timeslot) return;
                // this.lastTimeslot = timeslot;
                
                this.groups = [];

				this.showLoader();

                axios.post(this.getGroupsUrl, {
                    timeslot_id: timeslot.id,
                    date: Vue.moment(this.date).format('YYYY-MM-DD')
                }) // qs.stringify(this.serverParams)
                .then(response => {
					this.hideLoader();
					
                    this.groups = response.data.groups;
                }).catch(error => {
					this.hideLoader();

                    console.error(error);
                    Swal.fire({
                        icon: 'error',
                        title: this.translate('error'),
                    });
                });
            },

            loadHealthDeclaraction(date) {
                this.healthDeclaration.dirty = false;
                this.healthDeclaration.loading = true;
                this.healthDeclaration.selected = [];

                axios.post(this.getHealthDeclarationUrl, {
                    date: Vue.moment(date).format('YYYY-MM-DD')
                }) // qs.stringify(this.serverParams)
                .then(response => {
                    
                    this.healthDeclaration.loading = false;
                    this.healthDeclaration.selected = response.data.staff;

                }).catch(error => {
                    this.healthDeclaration.loading = false;

                    console.error(error);
                    Swal.fire({
                        icon: 'error',
                        title: this.translate('error'),
                    });
                });

            },

            onHealthDeclarationChange() {
                this.healthDeclaration.dirty = true;
                if(!this.$refs.staffMultiselect.isOpen) {
                    this.saveHealthDeclaraction();
                }
            },

            saveHealthDeclaraction() {
                if(!this.healthDeclaration.dirty) return;
                
                this.healthDeclaration.loading = true;

				axios.post(this.updateHealthDeclarationUrl, {
                    date: Vue.moment(this.date).format('YYYY-MM-DD'),
                    staff: this.healthDeclaration.selected,
                })
				.then(response => {
                    this.healthDeclaration.loading = false;
                    this.healthDeclaration.dirty = false;

					/* Swal.fire({
						icon: 'success',
						title: this.translate('reservations.update_health_declaration_success'),
					}); */
				}).catch(error => {
                    this.healthDeclaration.loading = false;

                    console.error(error);

                    Swal.fire({
                        icon: 'error',
                        title: this.translate('error'),
                    });
				});
            },

            onTimeslotClick(timeslot) {
                this.timeslot = timeslot;
                this.loadGroups(timeslot);
            },
            
            checkEmail() {
                this.emailChecked = false;
                this.checkEmailDebounce();
            },

            checkEmailDebounce: _.debounce(function() {
                if(this.checkEmailCancelToken) {
                    this.checkEmailCancelToken.cancel('cancel_token');
                    this.checkEmailCancelToken = null;
                }

                let cancelToken = axios.CancelToken;
                this.checkEmailCancelToken = cancelToken.source();
                this.add_form_user = null;
                
                axios.post(this.checkEmailUrl, {
                    email: this.add_form.email,
                }, {
                    cancelToken: this.checkEmailCancelToken.token
                })
                .then(response => {
                    
                    this.emailChecked = true;
                    this.checkEmailCancelToken = null;

                    if(response && response.data && response.data.found) {
                        this.add_form_user = response.data.user;
                    } else {
                        this.add_form_user = null;
                    }
                }).catch(error => {
                    if(error && error.message != 'cancel_token') {
                        this.emailChecked = true;
                        this.checkEmailCancelToken = null;
                        this.add_form_user = null;
                    }
                });
            }, 500),

            addReservation() {
                
                let form = {...this.add_form};
				
                form.date = Vue.moment(this.date).format('YYYY-MM-DD');
                form.timeslot_id = this.timeslot.id;
                form.user_id = this.add_form_user ? this.add_form_user.id : 0;

				this.errors = {};
				
				this.showLoader();

				axios.post(this.addReservationUrl, form)
				.then(response => {
					this.hideLoader();

					this.add_form.corona_1 = false;
					this.add_form.corona_2 = false;
					this.add_form.corona_3 = false;

                    this.loadDates();
                    this.loadGroups();
                    this.checkEmail();

					Swal.fire({
						icon: 'success',
						title: this.translate('reservations.add_reservation_success'),
					}).then(() => {

					});
				}).catch(error => {
					this.hideLoader();

					if(error && error.response && error.response.status == 422) {
						this.errors = error.response.data.errors;

						if(this.errors.length <= 0 && error.response.data.message) {
							Swal.fire({
								icon: 'error',
								title: error.response.data.message,
							});
						}
					} else {
						Swal.fire({
							icon: 'error',
							title: this.translate('error'),
						});
					}
				});

				return true;

            },

            checkIn(group) {

                this.showLoader();

                axios.post(this.checkInUrl, {
                    group_id: group.id,
                }) // qs.stringify(this.serverParams)
                .then(response => {
                    this.hideLoader();
                    
                    this.loadGroups();
                }).catch(error => {
                    this.hideLoader();

                    if(error && error.response && error.response.status == 422) {
                        if(error.response.data.message) {
                            Swal.fire({
                                icon: 'error',
                                title: error.response.data.message,
                            });
                        }
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: this.translate('error'),
                        });
                    }
                });
                
            },

            checkOut(group) {

                this.showLoader();

                axios.post(this.checkOutUrl, {
                    group_id: group.id,
                }) // qs.stringify(this.serverParams)
                .then(response => {
                    this.hideLoader();
                    
                    this.loadGroups();
                }).catch(error => {
                    this.hideLoader();

                    if(error && error.response && error.response.status == 422) {
                        if(error.response.data.message) {
                            Swal.fire({
                                icon: 'error',
                                title: error.response.data.message,
                            });
                        }
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: this.translate('error'),
                        });
                    }
                });

            },

            removeReservation(group) { 
                this.deleteConfirm.fire({
                }).then((result) => {
                    if(result.value) {

                        this.showLoader();

                        axios.post(this.removeReservationUrl, {
                            group_id: group.id,
                        }) // qs.stringify(this.serverParams)
                        .then(response => {
                            this.hideLoader();
                            
                            this.loadGroups();
                        }).catch(error => {
                            this.hideLoader();

                            if(error && error.response && error.response.status == 422) {
                                if(error.response.data.message) {
                                    Swal.fire({
                                        icon: 'error',
                                        title: error.response.data.message,
                                    });
                                }
                            } else {
                                Swal.fire({
                                    icon: 'error',
                                    title: this.translate('error'),
                                });
                            }
                        });

                    }
                });
            },

            openPrintWindow(event) {
                event.preventDefault();

                window.open(this.printUrl, 'popup', 'width=600,height=600');
            },

        },
        computed: {
            computedStaff: {
                get () {
                    return this.healthDeclaration.selected
                        .map(value => this.staff.find(option => option.id === value))
                        .filter(option => option != null)
                },
                set (v) {
                    this.healthDeclaration.selected = v.map(value => value.id)
                }
            },
            has_multiple_descriptions: function() {
                return Object.keys(this.timeslots).length > 1;
            },
            printUrl: function() {
                return this.routes.company.print.replace(':date:', Vue.moment(this.date).format('YYYY-MM-DD'));
                // .replace(':id:', this.timeslot.id)
            },
            printMonthlyUrl: function() {
                return this.routes.company.print_monthly.replace(':date:', Vue.moment(this.date).format('YYYY-MM'));
                // .replace(':id:', this.timeslot.id)
            },
            excelUrl: function() {
                return this.routes.company.excel.replace(':date:', Vue.moment(this.date).format('YYYY-MM-DD'));
                // .replace(':id:', this.timeslot.id)
            },
            excelMonthlyUrl: function() {
                return this.routes.company.excel_monthly.replace(':date:', Vue.moment(this.date).format('YYYY-MM'));
                // .replace(':id:', this.timeslot.id)
            },
            inside_groups: function() {
                return _.filter(this.groups, ['inside', 1]);
            },
            outside_groups: function() {
                return _.filter(this.groups, ['inside', 0]);
            },
			color_primary: function() {
                return this.company && this.company.color_primary ? this.company.color_primary : 'var(--primary)';
			},
            color_primary_faded: function() {
                return this.hexToRgbA(this.color_primary, 0.25);
			},
			color_primary_text: function() {
				let rgb = this.hexToRgbArray(this.color_primary);
				let yiq = ((rgb[0] * 299) + (rgb[1] * 587) + (rgb[2] * 114)) / 1000;
				let yiq_threshold = 150;

				return yiq >= yiq_threshold ? 'var(--dark)' : 'var(--white)';
			}
        }
    }
</script>
